// src/LoginPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { firebase, auth } from './firebaseConfig';
// If your project uses compat (firebase/compat/*), keep "firebase" like this.
// If you're on modular, you can do: import { PhoneAuthProvider } from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import { onAuthStateChanged } from 'firebase/auth';
import Layout from './components/Layout';
import './LoginPage.css';

// NOTE: No sessionManager import here while we stabilize login.

const LoginPage = () => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    // 1) Navigate when Firebase actually has a user.
    const un = onAuthStateChanged(auth, (user) => {
      if (user) {
        // user is signed in; go straight to subscription check
        navigate('/subscription-check', { replace: true });
      } else {
        setBusy(false);
      }
    });

    // 2) Start FirebaseUI (phone). We do NOT depend on its redirect callback.
    const uiConfig = {
      signInOptions: [
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: 'IN',
          recaptchaParameters: { type: 'image', size: 'invisible', badge: 'bottomleft' },
        },
      ],
      callbacks: {
        // We handle navigation ourselves.
        signInSuccessWithAuthResult: () => false,
        signInFailure: (e) => {
          console.error('FirebaseUI signInFailure', e);
          setErr(e?.message || 'Sign-in failed. Please try again.');
          setBusy(false);
        },
        uiShown: () => setBusy(false),
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    };

    // Ensure the container is empty before starting (avoids stale instances)
    const host = document.getElementById('firebaseui-auth-container');
    if (host) host.innerHTML = '';

    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
    ui.start('#firebaseui-auth-container', uiConfig);

    return () => {
      un();
      try { ui.reset(); } catch {}
    };
  }, [navigate]);

  // safety: don’t let overlay stay forever
  useEffect(() => {
    if (!busy) return;
    const t = setTimeout(() => setBusy(false), 15000);
    return () => clearTimeout(t);
  }, [busy]);

  return (
    <Layout>
      <div className="login-background">
        <div className="login-page-container">
          <div className="login-card">
            <h2>Tender Managers</h2>
            <p className="login-subtitle">Please Log in to Continue</p>
            {err && (
              <div style={{color:'#b91c1c', background:'#fee2e2', border:'1px solid #fecaca',
                           padding:'8px 10px', borderRadius:8, marginBottom:10}}>
                {err}
              </div>
            )}
            <div id="firebaseui-auth-container"></div>
          </div>
        </div>
      </div>

      {busy && (
        <div style={{
          position:'fixed', inset:0, background:'rgba(0,0,0,.35)',
          display:'flex', alignItems:'center', justifyContent:'center',
          zIndex:9999, backdropFilter:'blur(2px)'
        }}>
          <div style={{
            background:'#fff', padding:'16px 20px', borderRadius:12,
            boxShadow:'0 6px 20px rgba(0,0,0,.25)', fontSize:16
          }}>
            Signing you in…
          </div>
        </div>
      )}
    </Layout>
  );
};

export default LoginPage;
